<template>
  <div class="icon">
    <svg class="icon_svg" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 70.402 70.402">
      <g id="Group_320" data-name="Group 320" transform="translate(-174.561 -96.788)">
        <circle id="Ellipse_86" data-name="Ellipse 86" cx="35.201" cy="35.201" r="35.201" transform="translate(174.561 96.788)" :class="['svg-fill--' + color]" />
        <g id="Group_319" data-name="Group 319" transform="translate(0 -850.394)">
          <path id="Path_233" data-name="Path 233" d="M220.5,974.37A15.107,15.107,0,1,1,205.4,959.263,15.108,15.108,0,0,1,220.5,974.37" fill="none" stroke="#fff" stroke-miterlimit="10" stroke-width="3"/>
          <line id="Line_21" data-name="Line 21" x2="13.61" y2="13.61" transform="translate(215.221 985.45)" fill="none" stroke="#fff" stroke-miterlimit="10" stroke-width="3"/>
          <line id="Line_22" data-name="Line 22" x2="9.849" y2="9.849" transform="translate(218.982 989.211)" fill="none" stroke="#fff" stroke-miterlimit="10" stroke-width="9"/>
          <path id="Path_234" data-name="Path 234" d="M202.039,986.454a8.048,8.048,0,1,1-8.048-8.048,8.048,8.048,0,0,1,8.048,8.048" :class="['svg-fill--' + color]" stroke="#fff" stroke-miterlimit="10" stroke-width="3"/>
          <path id="Path_235" data-name="Path 235" d="M222.026,986.327" fill="#fff" stroke="#fff" stroke-miterlimit="10" stroke-width="3"/>
          <g id="Group_134" data-name="Group 134">
            <path id="Path_236" data-name="Path 236" d="M207.222,972.312a3.544,3.544,0,0,0,.419-.247c.054-.035.1-.075.156-.113.089-.066.174-.137.255-.21a4,4,0,1,0-5.689-.521c.041.052.083.1.127.155.084.093.168.183.26.268a4.026,4.026,0,0,0,.37.306c.053.038.1.078.157.114a3.971,3.971,0,0,0,.423.248,6.111,6.111,0,0,0-4.188,3.9,7.588,7.588,0,0,1,4.65,5.181h8.1C212.267,975.831,210.128,973.063,207.222,972.312Z" fill="#fff"/>
          </g>
          <path id="Path_237" data-name="Path 237" d="M204.19,985.28" fill="none" stroke="#fff" stroke-miterlimit="10" stroke-width="3"/>
          <path id="Path_238" data-name="Path 238" d="M190.154,986.064,193,988.913l5.171-5.171" fill="none" stroke="#fff" stroke-miterlimit="10" stroke-width="3"/>
        </g>
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'checks-on-government-icon',
  props: ['color']
}
</script>

<style lang="scss" scoped>
  @import '~@/components/sass/shared/colors';

  .icon{
    display: flex; -js-display: flex;
    height: 100%;
    align-items: center;
  }

  .icon_svg{
    flex: 0 0 30px;
    height: 30px;
    width: 30px;
  }

  .cls-2{fill: $gray-lightest;}

</style>



// WEBPACK FOOTER //
// src/components/shared/navigation/AttributesNavigation/assets/ChecksOnGovernmentIcon.vue